import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Tooltip,
} from "@mui/material";
import { ChangeEvent } from "react";
import InformationFillIcon from "remixicon-react/InformationFillIcon";
import { getActivitiesOptions } from "$utils/typeConstants";
import { Activity } from "$types/Activity";
import { theme } from "$utils/theme/bataillog";

type Props = {
  activities: Activity[];
  disabledActivities?: string[];
  disabledMessage?: string;
  onChange: (newActivities: Activity[]) => void;
  value: Activity[];
};

function ActivitiesCheckboxes({
  activities,
  disabledActivities,
  disabledMessage,
  onChange,
  value,
}: Props) {
  const activitiesOptions = getActivitiesOptions(activities);

  return (
    <FormGroup>
      {activitiesOptions.map((option) => {
        const isDisabled = disabledActivities.some(
          (disabledActivity) => disabledActivity === option._id
        );
        const checkbox = (
          <Box display="flex" alignItems="center" key={option._id}>
            <FormControlLabel
              checked={value?.some((a2) => a2._id === option._id)}
              disabled={isDisabled}
              control={<Checkbox color="primary" />}
              label={option.label}
              value={option.value}
              onChange={(
                event: ChangeEvent<HTMLInputElement>,
                checked: boolean
              ) => {
                if (checked) {
                  onChange([
                    ...value,
                    activities.find((a) => a._id === event.target.value),
                  ]);
                } else {
                  onChange(value.filter((a) => a._id !== event.target.value));
                }
              }}
              // if not provided, the FormControlLabel is full width and push the disabled Tooltip far away
              style={{ width: "fit-content" }}
            />
            {option.helpText && (
              <Tooltip placement="right" title={option.helpText}>
                <span>
                  <InformationFillIcon color={theme.color.gray5} />
                </span>
              </Tooltip>
            )}
          </Box>
        );

        return isDisabled ? (
          <Tooltip key={option._id} placement="right" title={disabledMessage}>
            {checkbox}
          </Tooltip>
        ) : (
          checkbox
        );
      })}
    </FormGroup>
  );
}

export default ActivitiesCheckboxes;
